import {ItemIconSize} from "../../../../../core/gd-components/icons/@const";
import {UIType} from "../../../../ui/@const";
import ProjectIconUI5 from "../../../../../core/gd-components/icons/project/project-icon-ui5";
import React from "react";
import ProjectSession from "../../../../../core/model2/project/project-session";


type Props = {
    style?                  : any

    project                 : ProjectSession
    level                   : number
    colorized?              : boolean

    isExpanded              : boolean

}


export default function NavigationMenuItemProject_Icon(props:Props) {

    // svg icons patch
    const iconSize = props.project.isCustomIcon ? ItemIconSize.SIZE_18 : ItemIconSize.SIZE_15
    const iconClasses = Classes('icon',{
        'm-r-9i' : props.project.isCustomIcon
    })
    //

    const isRootProject = props.level === 0;
    const hasNotArchivedChildren    = props.project.treeHasNotArchivedChildren


    // PAtch for asana
    if (gd.ui.type === UIType.ASANA && isRootProject) {
        return (
            <div className="flex-row-center-center w-20 h-20 min-w-20 min-h-20 border-radius-6 m-r-12"
                 style={{background: props.project.colorRGB}}>
                <ProjectIconUI5 className="ui5-color-white"
                                size={ItemIconSize.SIZE_12}
                                project={props.project}
                                colorize={false}/>
            </div>
        )
    }


    return (
        <ProjectIconUI5 className   = {iconClasses}
                        size        = {iconSize}
                        project     = {props.project}
                        colorize    = {props.colorized}
                        isExpanded  = {hasNotArchivedChildren && props.isExpanded} />
    )

}